import React, { FC } from 'react'

import { IconType } from '../../common/types'

const NucCirclePlus: FC<IconType> = ({
  iconColor = 'currentColor',
  ...svgProps
}) => {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...svgProps}
    >
      <path
        d='M0 12C0 5.39062 5.34375 0 12 0C18.6094 0 24 5.39062 24 12C24 18.6562 18.6094 24 12 24C5.34375 24 0 18.6562 0 12ZM12 17.25C12.6094 17.25 13.125 16.7812 13.125 16.125V13.125H16.125C16.7344 13.125 17.25 12.6562 17.25 12C17.25 11.3906 16.7344 10.875 16.125 10.875H13.125V7.875C13.125 7.26562 12.6094 6.75 12 6.75C11.3438 6.75 10.875 7.26562 10.875 7.875V10.875H7.875C7.21875 10.875 6.75 11.3906 6.75 12C6.75 12.6562 7.21875 13.125 7.875 13.125H10.875V16.125C10.875 16.7812 11.3438 17.25 12 17.25Z'
        fill={iconColor}
      />
    </svg>
  )
}

export default NucCirclePlus
